<template>
  <div class="content">
    <div class="page-inner">
      <h1 class="h4 page-title mb-4">{{ $t('release_promotion') }}</h1>

      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <h2>{{ $t('how_it_works') }}</h2>
            <div>
              {{ $t('release_promotion_description')}}<br/>
              <b>{{ $t('release_promotion_duration') }}</b>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <label>{{ $t('release_published_indiefy') }}</label>
              <select class="form-control" v-model="publishedByIndiefy">
                <option value="yes">{{ $t('yes') }}</option>
                <option value="no">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="form-group" v-if="publishedByIndiefy === 'yes'">
              <label>{{ $t('release' )}}</label>
              <select class="form-control" v-model="distribution">
                <option :value="distro._id" v-for="distro in distributions" v-bind:key="`distro_${distro._id}`">
                  {{ distro.artist.name }} - {{ distro.title }}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="publishedByIndiefy === 'no'">
              <label>{{ $t('destination_url') }}</label>
              <input v-model="trackUrl" type="url" class="form-control" placeholder="https://open.spotify.com/artist/2qG9ClNOYgpKl8bFL8rID6">
            </div>
            <div class="form-group">
              <label>{{ $t('add_similar_artists') }}</label>
              <form class="input-group mb-0" @submit.prevent="addArtist()">
                <input v-model="artist" type="text" class="form-control" placeholder="" aria-label="" aria-describedby="basic-addon1">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">{{ $t('add_artist') }}</button>
                </div>
              </form>
              <div class="mt-3 mb-3">
                <div class="tag-artist bg-info" v-for="(artist, index) in artists" v-bind:key="`artist_${index}`">
                  {{ artist }}
                  <span class="remove-artist" @click="removeArtist(index)">
                    <i class="fa fa-times"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label for="">{{ $t('vertical_video') }}</label>
                  <div class="progress" v-if="videoProgress">
                    <div class="progress-bar bg-success" role="progressbar" :style="`width: ${videoProgress}px;`" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                  <input
                    v-show="!videoUrl && !videoProgress"
                    ref="videoFile"
                    @change="uploadVideo()"
                    type="file"
                    id="videofile"
                    class="form-control form-control-file"
                    accept=".avi, .mp4, .mpeg, .webm, .mov, .wmv"
                    required
                  />
                  <p v-if="videoUrl">
                    <span>
                      {{ $t('file_uploaded') }} <i class="fa fa-check text-success ml-1"></i>
                    </span>
                    <button type="button" class="btn btn-sm ml-3" @click="replaceFile()">
                      {{ $t('replace_file') }} <i class="fa fa-trash ml-1"></i>
                    </button>
                  </p>
                  <div class="mt-4">
                    <a class="badge badge-primary mr-2 mb-1" href="https://invideo.io/preview-link?id=1107419" target="_blank">Example Video #1</a>
                    <a class="badge badge-primary mr-2 mb-1" href="https://invideo.io/preview-link?id=1184342" target="_blank">Example Video #2</a>
                  </div>
                </div>

                <p class="mt-4 alert alert-info mb-3">
                  {{ $t('if_you_dont_have_video') }}
                  <a href="https://invideo.io/" target="_blank">https://invideo.io/</a>
                </p>

                <div class="text-right mt-4">
                  <div>{{ $t('campaign_duration') }}:</div>
                  <div class="h4">
                    30 {{ $t('days') }}
                  </div>
                  <div>Cost:</div>
                  <div class="h4">
                    $250.00 USD
                  </div>
                  <div class="mt-4 mb-4">
                    <button type="button" class="btn btn-lg btn-success" @click="gotoCheckout()">
                      {{ $t('continue_checkout') }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center d-none d-lg-block d-xl-block">
                <img src="/static/img/services/phone-resolution.png" width="50%"/>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Select2 from './utils/Select2'
import countries from '../data/countries'
import Services from '../services/services'
import Upload from '../services/upload'
import Distributions from '../services/distributions'
import _ from 'underscore'

export default {
  name: 'SpotifyGrowth',
  data: function () {
    return {
      publishedByIndiefy: 'yes',
      distributions: [],
      distribution: '',
      trackUrl: '',
      artist: '',
      videoUrl: '',
      countries: _.map(countries, (country) => { return { text: country.name, id: country.name } }),
      user: {},
      videoProgress: 0,
      artists: []
    }
  },
  methods: {
    replaceFile: function () {
      this.videoUrl = ''
    },
    uploadVideo: function () {
      let fileElement = this.$refs.videoFile
      this.videoUrl = ''

      if (fileElement && fileElement.files && fileElement.files[0]) {
        let file = fileElement.files[0]

        this.videoProgress = 10

        Upload.uploadVideo(file, event => {
          if (parseInt((event.loaded / event.total) * 100) > 0) {
            this.videoProgress = parseInt((event.loaded / event.total) * 100)
          }

          this.$forceUpdate()
        }).then(response => {
          this.videoUrl = response.data
          this.videoProgress = 0
        }).catch(() => {
          this.videoProgress = 0
        })
      }
    },
    gotoCheckout: function () {
      if (this.publishedByIndiefy === 'no' && !this.trackUrl) {
        return this.$notify({ message: this.$t('please_type_destination_url') }, 'warning', 'fa-exclamation-triangle')
      }

      if (this.publishedByIndiefy === 'yes' && !this.distribution) {
        return this.$notify({ message: this.$t('select_a_release_title') }, 'warning', 'fa-exclamation-triangle')
      }

      if (this.artists.length < 4) {
        return this.$notify({ message: this.$t('provide_similar_artists') }, 'warning', 'fa-exclamation-triangle')
      }

      if (!this.videoUrl) {
        return this.$notify({ message: this.$t('upload_vertical_video') }, 'warning', 'fa-exclamation-triangle')
      }

      let serviceData = {
        user: this.user,
        service: 'spotify-growth',
        paid: 0,
        video_url: this.videoUrl,
        similar_artists: this.artists
      }

      if (this.publishedByIndiefy === 'yes') {
        serviceData.distribution = this.distribution
      } else {
        serviceData.track_url = this.trackUrl
      }

      Services.save(serviceData).then(response => {
        let service = response.data
        let price = 'price_1HcGq9K9qKRAJ5zqDBbjoXqE'

        if (this.user.role === 'admin') {
          price = 'price_1Kj7oeK9qKRAJ5zq55DVwuGN'
        }

        this.stripe.redirectToCheckout({
          lineItems: [{ price, quantity: 1 }],
          mode: 'payment',
          successUrl: `https://indiefy.net/user/services?success=1&service_id=${service._id}`,
          cancelUrl: 'https://indiefy.net/services',
          customerEmail: this.user.email
        }).then(result => {
          if (result.error) {
            this.$notify({ message: result.error.message }, 'danger', 'fa-exclamation-triangle')
          }
        })
      }).catch(() => {})
    },
    removeArtist: function (index) {
      this.artists.splice(index, 1)
    },
    addArtist: function () {
      if (this.artist) {
        if (_.contains(this.artists, this.artist)) {
          return this.$notify({ message: 'You already added this artist' }, 'warning', 'fa-exclamation-triangle')
        }

        this.artists.push(this.artist)
        this.artist = ''
      }
    }
  },
  mounted: function () {
    setTimeout(() => {
      window.prerenderReady = true

      window.$('html, body').animate({
        scrollTop: 0
      }, 500)
    }, 100)
  },
  created: function () {
    this.user = this.$user
    let stripeKey = 'pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm'

    if (window.location.href.match(/localhost|development|staging/)) {
      stripeKey = 'pk_test_WD9FBh5jNgV5uO1eFQBkLdAl000Ey6vyno'
    }

    this.stripe = window.Stripe(stripeKey)

    if (this.user && this.user.country) {
      let country = _.find(countries, country => country.code === this.user.country)

      if (country) {
        this.country = country.name
      }
    }

    Distributions.getAll({ status: 3 }).then(response => {
      this.distributions = response.data

      if (this.$route.query.release) {
        this.distribution = this.$route.query.release
      }
    })

    window.document.title = this.$t('services_title') + ' | Indiefy'
    window.$('meta[name="description"]').attr('content', this.$t('services_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('services_description'))
  },
  components: {
    Select2
  }
}
</script>
<style lang="scss" scoped>
.StripeElement {
  margin-top: 4px;
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid #ebedf2;
  border-radius: 4px;
  background-color: white;
  margin-bottom: 10px;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.StripeElement.complete {
  border: 2px solid green;
}

.line-through {
  font-size: 12px;
  text-decoration: line-through;
}

.list-group-item {
  display: block !important;
}

.card img {
  border-radius: 3px;
}

.tag-artist.bg-info {
  font-size: 16px;
  color: white;
  background-color: #17a2b8 !important;
  border-radius: 6px;
  padding: 6px 28px 6px 12px;
  position: relative;
  margin-bottom: 8px;
  margin-right: 8px;
}

.tag-artist {
  display: inline-block;

  .remove-artist {
    position: absolute;
    top: 7px;
    right: 10px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SpotifyGrowth.vue